import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import { listCaseAgenticMissionStatuses, type CaseAgenticMissionLink } from "../index";
import { caseCheckKeys } from "./keys";
import { caseCheckQueryDefaults } from "./options";

type Options = Omit<
  UseQueryOptions<Record<string, CaseAgenticMissionLink>>,
  "queryKey" | "queryFn"
>;

export function useCaseCheckMissionStatuses(caseIds: readonly string[], options?: Options) {
  return useQuery({
    queryKey: caseCheckKeys.missionStatus(caseIds),
    queryFn: () => listCaseAgenticMissionStatuses([...caseIds]),
    enabled: caseIds.length > 0 && (options?.enabled ?? true),
    ...caseCheckQueryDefaults,
    ...options,
  });
}
